import React from 'react';

import type { AvatarProps } from '@mui/material';
import { Avatar, Box } from '@mui/material';
import { ImageModal } from './image_modal';

export type EnlargeableAvatarProps = {
  fullWidth?: boolean;
  fullHeight?: boolean;
  noBorderRadius?: boolean;
  containerProps?: React.ComponentProps<typeof Box>;
} & AvatarProps;

export const EnlargeableAvatar = ({
  src,
  sx,
  fullWidth,
  fullHeight,
  noBorderRadius,
  containerProps,
  ...avatarProps
}: EnlargeableAvatarProps) => {
  const [showImageModal, setShowImageModal] = React.useState(false);
  const onCloseHandler = () => setShowImageModal(false);

  const onClickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    setShowImageModal(true);

    containerProps?.onClick?.(event);
  };

  return (
    <>
      <Box
        {...containerProps}
        onClick={onClickHandler}
        sx={[
          { cursor: 'pointer' },
          fullWidth && { width: '100%' },
          fullHeight && { height: '100%' },
          ...(Array.isArray(containerProps?.sx) ? containerProps?.sx ?? [] : [containerProps?.sx]),
        ]}
      >
        <Avatar
          src={src}
          {...avatarProps}
          sx={[
            fullWidth && { width: '100%' },
            fullHeight && { height: '100%' },
            noBorderRadius && { borderRadius: 'unset' },
            ...(Array.isArray(sx) ? sx ?? [] : [sx]),
          ]}
        />
      </Box>

      <ImageModal src={src} open={showImageModal} onClose={onCloseHandler} />
    </>
  );
};
